MS = window.MS || {};
(function($) {
  MS.pinksalt_content_cards = {
    selectors: {
      section: '.ms-ps-content-cards',
      overlay: '.ms-ps-content-cards__overlay'
    },
    init: function() {
      // var _this = this;
      // var adjacent = $(_this.selectors.section).width();
      // var opposite = $(_this.selectors.section).height();
      // var tangentShift = Math.tanh(adjacent / opposite);
      // var tilt = Math.abs(tangentShift - 90);
    }
  };
})(jQuery);
